const useTextInputValidation = (fieldName, validationRules = []) => {
  const validate = value => {
    // Handle undefined/null values first
    if (!value && value !== 0) {
      const requiredRule = validationRules.find(rule => rule.type === 'required')
      if (requiredRule) {
        return `${fieldName?.replace('*', '')} ${requiredRule.msg}`
      }
      return null
    }

    const val = value.trim()
    let errorList = []
    const rules = [...validationRules]
    const label = fieldName?.replace('*', '')
    const decimalNumberRegex = /^-?(?:\d+\.\d+|\d+|\.\d+)$/
    const specialCharRegex = /[^a-zA-Z0-9\s]/

    rules.forEach(rule => {

      if (rule.type === 'required' && val === '') {
        errorList.push(`${rule.excludeLabel ? "" : label} ${rule.msg}`)

      }
      if (rule.type === 'number' && isNaN(val)) {
        errorList.push(`${rule.excludeLabel ? "" : label} ${rule.msg}`)
      }
      if (rule.type === 'maxLength' && val && val.length > rule.limit) {
        errorList.push(`${rule.excludeLabel ? "" : label} ${rule.msg}`)
      }
      if (rule.type === 'minLength' && val.length < rule.limit) {
        errorList.push(`${rule.excludeLabel ? "" : label} ${rule.msg}`)
      }
      if (rule.type === 'pattern' && !new RegExp(rule.regex).test(val)) {
        errorList.push(`${rule.excludeLabel ? "" : label} ${rule.msg}`)
      }
      if (rule.type === 'decimal' && !decimalNumberRegex.test(val)) {
        errorList.push(`${rule.excludeLabel ? "" : label} ${rule.msg}`)
      }
      if (rule.type === 'noSpecialChar' && specialCharRegex.test(val)) {
        errorList.push(`${rule.excludeLabel ? "" : label} ${rule.msg}`)
      }
    })

    return errorList[0]
  }

  const onChange = value => {
    return validate(value)
  }

  return { onChange }
}

export default useTextInputValidation
